module.exports = __webpack_public_path__ + "media/footer/footerBackground-4bf1748c.png";